export function getHourOnly(time: string): number {
    return parseInt(time.slice(0, 2));
}

export function toFullHour(time: string, hour: number) {
    return getHourOnly(time) === hour;
}

export function getMinutesOnly(time: string): number {
    return parseInt(time.slice(3, 5));
}

export function hourToNumber(time: string | undefined): number {
    if (time === undefined || time === null || time === '') {
        return 0;
    }

    const timeParts = time.split(':');
    return Number(timeParts[0]) + Number(timeParts[1]) / 60;
}

export function numberToHour(time: number | undefined): string {
    if (time === undefined || time === null || time === 0) {
        return '';
    }

    const hour = Math.floor(time);
    const minutes = (time - hour) * 60;

    return `${hour}:${minutes.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
    })}`;
}
